import DataAccess from './constants';
import Moment from 'moment';
import { genfunction } from '../helpers';

const path = 'TourEvents'

export const apiExtraItems = (Id, NextTourDate, checkFromNextTourDate, isDisplayArea, isListView, currentView, listViewSearchDays, tourEventsList) => {

    let year = "";
    let month = "";
    let date = "";
    let url = "";
    let lastDay;

    if (tourEventsList) {
        url = DataAccess.apiUrl + path + "?TourEventList=" + tourEventsList;
    }
    else {
        year = Moment(NextTourDate).format('YYYY');
        month = Moment(NextTourDate).format('M');
        date = Moment(NextTourDate).format('d');

        if (!checkFromNextTourDate) {
            NextTourDate = year + '-' + month + '-' + 1;
        }

        if (isListView && listViewSearchDays) {

            if (NextTourDate === undefined) {
                NextTourDate = year + '-' + month + '-' + date;
            }

            lastDay = genfunction.AddToDateDate(NextTourDate, listViewSearchDays);
        }
        else {
            lastDay = Moment(new Date(year, month, 0, 23, 59, 59)).format('YYYY-MM-DD');
        }

        if (currentView && currentView === "SingleDay") {
            lastDay = NextTourDate;
        }

        if (currentView && currentView === "WeekView") {
            lastDay = genfunction.AddWeekDays(NextTourDate);
        }

        if (checkFromNextTourDate && NextTourDate === undefined) {
            NextTourDate = year + '-' + month + '-' + 1;
        }

        url = isDisplayArea ?
            DataAccess.apiUrl + path + "?DisplayArea=" + Id + "&From=" + NextTourDate + "&To=" + lastDay
            : DataAccess.apiUrl + path + "?BookingTypeID=" + Id + "&From=" + NextTourDate + "&To=" + lastDay;
    }

    url += "&OnlineOnly=true";

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}


